import { AfterViewInit, Component } from '@angular/core';

import { getAnalytics, logEvent } from 'firebase/analytics';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  title = 'Bemddops Website';

  // Loader
  isLoading: boolean;

  ngOnInit() {
    this.isLoading = true;

    setTimeout(() => {
      this.isLoading = false;
    }, 600);
  }

  ngAfterViewInit(): void {
    const analytics = getAnalytics();
    logEvent(analytics, 'eventname', {
      firsttimeuser: true,
      username: 'bemddops-website',
    });
  }
}
